var _linearGradient, _radialGradient, _linearGradient2, _radialGradient2, _radialGradient3, _radialGradient4, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEdge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 256,
    viewBox: "0 0 256 256",
    width: 256,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 58.7043,
    x2: 236.9865,
    y1: 177.0202,
    y2: 177.0202
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0c59a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#114a8b"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 161.83,
    cy: 788.4008,
    gradientTransform: "matrix(.9999 0 0 .9498 -4.6217 -570.3868)",
    gradientUnits: "userSpaceOnUse",
    r: 95.38
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 152.7713,
    x2: 41.3976,
    y1: 99.7463,
    y2: 221.0585
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1b9de2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1595df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0680d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078d4"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: -773.6357,
    cy: 746.7146,
    gradientTransform: "matrix(.15 -.9898 .8 .12 -410.7182 -656.3412)",
    gradientUnits: "userSpaceOnUse",
    r: 143.24
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 230.5926,
    cy: -106.0381,
    gradientTransform: "matrix(-.0399975 .9998 -2.1299 -.07998414 -190.7749 -191.6354)",
    gradientUnits: "userSpaceOnUse",
    r: 202.4299
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#35c1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#34c1ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2fc2df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2bc3d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#36c752"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 536.3567,
    cy: -117.7029,
    gradientTransform: "matrix(.28 .9598 -.78 .23 -1.9279 -410.3179)",
    gradientUnits: "userSpaceOnUse",
    r: 97.34
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66eb6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66eb6e",
    stopOpacity: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m231 190.5c-3.4 1.8-6.9 3.4-10.5 4.7-11.5 4.3-23.6 6.5-35.9 6.5-47.3 0-88.5-32.5-88.5-74.3.1-11.4 6.4-21.9 16.4-27.3-42.8 1.8-53.8 46.4-53.8 72.5 0 73.9 68.1 81.4 82.8 81.4 7.9 0 19.8-2.3 27-4.6l1.3-.4c27.6-9.5 51-28.1 66.6-52.8 1.2-1.9.6-4.3-1.2-5.5-1.3-.8-2.9-.9-4.2-.2z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m231 190.5c-3.4 1.8-6.9 3.4-10.5 4.7-11.5 4.3-23.6 6.5-35.9 6.5-47.3 0-88.5-32.5-88.5-74.3.1-11.4 6.4-21.9 16.4-27.3-42.8 1.8-53.8 46.4-53.8 72.5 0 73.9 68.1 81.4 82.8 81.4 7.9 0 19.8-2.3 27-4.6l1.3-.4c27.6-9.5 51-28.1 66.6-52.8 1.2-1.9.6-4.3-1.2-5.5-1.3-.8-2.9-.9-4.2-.2z",
    fill: "url(#b)",
    opacity: 0.35
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m105.7 241.4c-8.9-5.5-16.6-12.8-22.7-21.3-26.3-36-18.4-86.5 17.6-112.8 3.8-2.7 7.7-5.2 11.9-7.2 3.1-1.5 8.4-4.1 15.5-4 10.1.1 19.6 4.9 25.7 13 4 5.4 6.3 11.9 6.4 18.7 0-.2 24.5-79.6-80-79.6-43.9 0-80 41.7-80 78.2-.2 19.3 4 38.5 12.1 56 27.6 58.8 94.8 87.6 156.4 67.1-21.1 6.6-44.1 3.7-62.9-8.1z",
    fill: "url(#c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m105.7 241.4c-8.9-5.5-16.6-12.8-22.7-21.3-26.3-36-18.4-86.5 17.6-112.8 3.8-2.7 7.7-5.2 11.9-7.2 3.1-1.5 8.4-4.1 15.5-4 10.1.1 19.6 4.9 25.7 13 4 5.4 6.3 11.9 6.4 18.7 0-.2 24.5-79.6-80-79.6-43.9 0-80 41.7-80 78.2-.2 19.3 4 38.5 12.1 56 27.6 58.8 94.8 87.6 156.4 67.1-21.1 6.6-44.1 3.7-62.9-8.1z",
    fill: "url(#d)",
    opacity: 0.41
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m152.3 148.9c-.8 1-3.3 2.5-3.3 5.7 0 2.6 1.7 5.1 4.7 7.2 14.4 10 41.5 8.7 41.6 8.7 10.7 0 21.1-2.9 30.3-8.3 18.8-11 30.4-31.1 30.4-52.9.3-22.4-8-37.3-11.3-43.9-21.2-41.5-67-65.4-116.7-65.4-70 0-127 56.2-128 126.2.5-36.5 36.8-66 80-66 3.5 0 23.5.3 42 10.1 16.3 8.6 24.9 18.9 30.8 29.2 6.2 10.7 7.3 24.1 7.3 29.5 0 5.3-2.7 13.3-7.8 19.9z",
    fill: "url(#e)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m152.3 148.9c-.8 1-3.3 2.5-3.3 5.7 0 2.6 1.7 5.1 4.7 7.2 14.4 10 41.5 8.7 41.6 8.7 10.7 0 21.1-2.9 30.3-8.3 18.8-11 30.4-31.1 30.4-52.9.3-22.4-8-37.3-11.3-43.9-21.2-41.5-67-65.4-116.7-65.4-70 0-127 56.2-128 126.2.5-36.5 36.8-66 80-66 3.5 0 23.5.3 42 10.1 16.3 8.6 24.9 18.9 30.8 29.2 6.2 10.7 7.3 24.1 7.3 29.5 0 5.3-2.7 13.3-7.8 19.9z",
    fill: "url(#f)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdge);
export default __webpack_public_path__ + "static/media/icon_edge.071b935d88186e904ce8f21d6f277ec4.svg";
export { ForwardRef as ReactComponent };